import React from 'react';
import { P } from 'xpi-black-ui/Base/Typography';
import { CustomOperationContainer, CustomLinkOperationCard } from './styles';
import { Props, DefaultProps } from './shape';

const Operations = ({ operations, descricaoMenu }) => {
  const RenderOperations = () => (
    <CustomOperationContainer>
      {operations?.map(operation => (
        <CustomLinkOperationCard
          key={operation?.operacaoId?.toString()}
          id={operation?.operacaoId?.toString()}
          data={{
            isHighlight: operation?.isHighlight,
            tagList: [operation?.tipoEstrategia],
            logoSRC: operation?.imagem,
            title: `${operation?.ativoNome} - ${operation?.bolsaNegociacao}`,
            subtitle: operation?.estrutura?.nome,
            maxProfit: operation?.lucroMaximoFomatado,
            maxLoss: operation?.prejuizoMaximoFomatado,
            commission: operation?.comissaoFormatado,
            price: operation?.precoOperacaoFormatado,
            closingDate: operation?.dataEncerramentoFormatado,
            objective: operation?.objetivo,
          }}
        />
      ))}
    </CustomOperationContainer>
  );

  return (
    operations.length > 0
      ? <RenderOperations />
      : (
        <>
          <P style={{ marginBottom: '16px'}}>No momento não há operações disponíveis de {descricaoMenu} nesta página. </P>
          <P>Para mais informações, favor entrar em contato com a mesa de operações.</P>
        </>
      )
  );
};

Operations.defaultProps = DefaultProps;
Operations.propTypes = Props;

export default Operations;
